import { Link, useLocation } from "react-router-dom";
import { Home, Truck, FileText, Calendar, Users } from "lucide-react";
import { cn } from "@/lib/utils";
import { useDriver } from "@/context/DriverContext";

const BottomNavigation = () => {
  const location = useLocation();
  const { todayCoordinations, tomorrowCoordinations } = useDriver();

  const showCoordinationTab =
    (todayCoordinations?.length ?? 0) > 0 || (tomorrowCoordinations?.length ?? 0) > 0;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 py-2 safe-area-inset-bottom">
      <div className="flex items-center justify-around px-4 max-w-full">
        <Link
          to="/"
          className={cn(
            "flex flex-col items-center text-xs py-1 px-2 min-w-0 flex-1",
            location.pathname === "/" ? "text-primary" : "text-gray-500"
          )}
        >
          <Home className="h-5 w-5 mb-1 flex-shrink-0" />
          <span className="truncate">Inicio</span>
        </Link>

        <Link
          to="/trips"
          className={cn(
            "flex flex-col items-center text-xs py-1 px-2 min-w-0 flex-1",
            location.pathname === "/trips" ? "text-primary" : "text-gray-500"
          )}
        >
          <Truck className="h-5 w-5 mb-1 flex-shrink-0" />
          <span className="truncate">Viajes</span>
        </Link>

        <Link
          to="/my-availabilities"
          className={cn(
            "flex flex-col items-center text-xs py-1 px-2 min-w-0 flex-1",
            location.pathname === "/my-availabilities" ? "text-primary" : "text-gray-500"
          )}
        >
          <Calendar className="h-5 w-5 mb-1 flex-shrink-0" />
          <span className="truncate">Disponibilidad</span>
        </Link>

        <Link
          to="/invoices"
          className={cn(
            "flex flex-col items-center text-xs py-1 px-2 min-w-0 flex-1",
            location.pathname === "/invoices" ? "text-primary" : "text-gray-500"
          )}
        >
          <FileText className="h-5 w-5 mb-1 flex-shrink-0" />
          <span className="truncate">Facturas</span>
        </Link>

        {showCoordinationTab && (
          <Link
            to="/coordination"
            className={cn(
              "flex flex-col items-center text-xs py-1 px-2 min-w-0 flex-1",
              location.pathname === "/coordination" ? "text-primary" : "text-gray-500"
            )}
          >
            <Users className="h-5 w-5 mb-1 flex-shrink-0" />
            <span className="truncate">Coord.</span>
          </Link>
        )}
      </div>
    </div>
  );
};

export default BottomNavigation;
